/**
 * Shared password policy validation.
 * Rules: 8+ characters, 1 uppercase, 1 lowercase, 1 digit.
 * Returns an array of unmet rule messages (empty = valid).
 */
export function validatePassword(pw: string): string[] {
  const errors: string[] = [];
  if (!pw || pw.length < 8)  errors.push('Minimum 8 characters');
  if (!/[A-Z]/.test(pw))     errors.push('At least 1 uppercase letter');
  if (!/[a-z]/.test(pw))     errors.push('At least 1 lowercase letter');
  if (!/[0-9]/.test(pw))     errors.push('At least 1 number');
  return errors;
}
